module.exports = __webpack_public_path__ + "assets/img/optionInPreparationImage.5c39227c.jpg";